
// **************product slider section js********************//
jQuery(document).ready(function($){

  //   code to show and hide header top information link on click of three parallel dots image
  $('ul li.information-links').click( function(){
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
    } 
    else {
      $('li.information-links.open').removeClass('open');
      $(this).addClass('open');
    }
  }); 

  //   code to show and hide header top information link on click of any where in document
  $(document).bind('click', function(event) {
    if (!$(event.target).parents().addBack().is('ul li.information-links')) {
      $('ul li.information-links').removeClass('open');
    }
  });

  // code to adjust search box
  var wHeight = window.innerHeight;
  //search bar middle alignment
  $('#mk-fullscreen-searchform').css('top', wHeight / 2);
  //reform search bar
  jQuery(window).resize(function() {
    wHeight = window.innerHeight;
    $('#mk-fullscreen-searchform').css('top', wHeight / 2);
  });
  // Search
  $('#search-button').click(function() {
    console.log("Open Search, Search Centered");
    $("div.mk-fullscreen-search-overlay").addClass("mk-fullscreen-search-overlay-show");
  });
  $("a.mk-fullscreen-close").click(function() {
    console.log("Closed Search");
    $("div.mk-fullscreen-search-overlay").removeClass("mk-fullscreen-search-overlay-show");
  });

  // show and hide search box on click of navigation search icon
  $(".search").click(function(){
    $(".search-box").toggleClass("search-box-open");
  });
  $('#search-close').click(function(){
    $('#search-box').removeClass('search-box-open');
  });

  // set with of mega menu
  var pc_navigation_width = $('.site-nav').width();
  $('.mega-menu').css('width',pc_navigation_width+'px');

  // jquery code to change mega menu offer title,image and link
  $('.mega-menu-link a').mouseenter(function(){
    var offer_link=$(this).parent().parent().find('.hidden a').attr('href');
    var offer_img=$(this).parent().parent().find('.hidden span').html();
    var offer_text=$(this).parent().parent().find('.hidden .menu-title').html();
    $(this).parents('.drop_menu').find('.offer_code_info a').attr('href',offer_link);
    $(this).parents('.drop_menu').find('.offer_code_info img').attr('src',offer_img);
    $(this).parents('.drop_menu').find('.offer_code_info span').html(offer_text);
    $(this).parents('.drop_menu').find(".offer_code_info #featured-img-div").attr('class','');
  });
  $(".mega-menu-link a").mouseleave(function(){
    var main_menu_link = $(this).parents('.relative-position').find('.main-img-menu a').attr('href');
    var main_menu_img = $(this).parents('.relative-position').find('.main-img-menu img').attr('src');
    var main_menu_text = $(this).parents('.relative-position').find('.main-img-menu span').html();
    var main_menu_div = $(this).parents('.relative-position').find('.main-img-menu div').attr('class');

    $(this).parents('.drop_menu').find(".cat-img a").attr('href',main_menu_link);
    $(this).parents('.drop_menu').find(".cat-img .featured-img").attr('src','');
    $(this).parents('.drop_menu').find(".cat-img span").html(main_menu_text);
    $(this).parents('.drop_menu').find(".cat-img #featured-img-div").attr('class',main_menu_div.replace(/,/g, ' '));

  });

  //   homepage brand slider
  $('.featured-slide').slick({
    //centerPadding: '60px',
    lazyLoad: 'ondemand',
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: true,
          slidesToShow: 1,
          centerMode: true,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  // owl carousel code for product detail page shipping info image slider
  $('#desc_icon.owl-carousel').owlCarousel({
    items:3,
    navigation : true,
    nav:true,
    dots: false,
    itemsTablet: [768,3],
    itemsTabletSmall: [650,1],
    itemsMobile:[479,1]
  });

  //  code to show tooltip on product detail page slider   
  $('[data-toggle="tooltip"]').tooltip();

});

